import { Observer } from 'mobx-react-lite';
import React from 'react';
import { useControllers } from '../../hooks/controller.hooks';
import { useObservableRef } from '../../hooks/useObservableRef.hook';
import { makeActionConfig } from '../../utils/actionConfig.utils';
import { checkErrorForRecaptchaFailure } from '../../utils/loadRecaptcha.utils';
import { useStore } from '../../utils/mobx.utils';
import BaseHeader from '../BaseHeader/BaseHeader';
import BaseInput from '../BaseInput/BaseInput';
import BaseSelector from '../BaseSelector/BaseSelector';
import BaseSpacer from '../BaseSpacer/BaseSpacer';
import CurrencyRenderer from '../CurrencyRenderer/CurrencyRenderer';
import DOMCopyButton from '../DOMCopyButton/DOMCopyButton';
import ErrorRenderer from '../ErrorRenderer/ErrorRenderer';
import InfoTable from '../InfoTable/InfoTable';
import OnceOffVisitorPaymentForm from '../OnceOffVisitorPaymentForm/OnceOffVisitorPaymentForm';
import ShadedBlock from '../ShadedBlock/ShadedBlock';
import './DonateForm.scss';
var defaultOptions = [100, 50, 25, 10, 5];
var DISABLE_DONATION = false;
var DonateForm = function (props) {
    var UI = useControllers().UI;
    var s = useStore(function () { return ({
        amount: 50,
    }); });
    var dismiss = function () {
        window.location.href = '/';
    };
    var onDonationSuccess = function () {
        UI.DIALOG.positive({
            heading: 'Thank you for your generous donation.',
            body: 'Your contribution will help us keep providing professional services for every person in need. We will send you a donation confirmation via your preferred means of communication shortly.',
            actions: [
                makeActionConfig('Go back to homepage', dismiss)
            ]
        });
    };
    var onDonationError = function (e) {
        checkErrorForRecaptchaFailure(e);
        UI.DIALOG.error({
            heading: 'Failed to complete your donation request',
            body: function () { return React.createElement(React.Fragment, null,
                React.createElement("p", null, "If the request had failed due to a recaptcha error, please try submitting the form again. You will be asked a simple math question. Otherwise, please double check the form details."),
                React.createElement(ErrorRenderer, { error: e, messageIsUserFriendly: true })); }
        });
    };
    var appName = 'turn2me';
    var confirmationMessageRenderer = function (a) { return React.createElement(React.Fragment, null,
        "Please confirm that you are donating ",
        React.createElement(CurrencyRenderer, { value: a }),
        " to ",
        appName,
        "."); };
    var buttonLabelRenderer = function (a) { return React.createElement(React.Fragment, null,
        "Donate ",
        React.createElement(CurrencyRenderer, { value: a })); };
    var bankInfoRef = useObservableRef();
    return React.createElement(Observer, { children: function () { return (React.createElement("div", { className: "DonateForm" },
            DISABLE_DONATION
                ? React.createElement("div", { className: "donate-page__error-message" },
                    React.createElement("h2", null, "We are currently experiencing technical issues with our payment processing."),
                    React.createElement("p", null,
                        React.createElement("strong", null, "If you would like to make a much appreciated donation to Turn2Me, we would kindly request that you make a payment directly to our bank account, details below."),
                        " Thank you for your patience and vital support."))
                : React.createElement(React.Fragment, null,
                    React.createElement("h3", { className: "DonateFormHeading" }, "Select your donation amount"),
                    React.createElement(ShadedBlock, { className: "DonationAmountSelector", spaceChildren: true },
                        React.createElement(BaseSelector, { options: defaultOptions, valueGetter: function (o) { return o; }, optionLabelRenderer: function (o) { return React.createElement(CurrencyRenderer, { value: o }); }, form: s, field: 'amount' }),
                        React.createElement(BaseInput, { label: "Or enter a value (EUR):", form: s, field: "amount", type: "number", min: 1, step: 0.01 })),
                    React.createElement(BaseSpacer, { size: "2em" }),
                    React.createElement("h3", { className: "DonateFormHeading" }, "Enter your banking information"),
                    React.createElement(OnceOffVisitorPaymentForm, { amount: s.amount, onSuccess: onDonationSuccess, onError: onDonationError, buttonLabelRenderer: buttonLabelRenderer, confirmationMessageRenderer: confirmationMessageRenderer })),
            React.createElement(BaseSpacer, null),
            React.createElement(ShadedBlock, null,
                React.createElement(BaseHeader, { heading: "Donations can also be sent directly to the following details.", color: "red", endSlot: React.createElement(DOMCopyButton, { targetRef: bankInfoRef, showButtonBackground: true }) },
                    React.createElement("p", null, "* You can click the copy button on the right to copy the following information.")),
                React.createElement(BaseSpacer, { size: "sm" }),
                React.createElement(InfoTable, { tableRef: bankInfoRef },
                    React.createElement("tbody", null,
                        React.createElement("tr", null,
                            React.createElement("th", null, "Bank Name:"),
                            React.createElement("td", null, "Allied Irish Bank")),
                        React.createElement("tr", null,
                            React.createElement("th", null, "Name on Account:"),
                            React.createElement("td", null, "Turn2me")),
                        React.createElement("tr", null,
                            React.createElement("th", null, "Bank Branch:"),
                            React.createElement("td", null, "Main Street, Rathfarnham, Dublin 14, Ireland")),
                        React.createElement("tr", null,
                            React.createElement("th", null, "Bank Sort Code:"),
                            React.createElement("td", null, "93-32-95")),
                        React.createElement("tr", null,
                            React.createElement("th", null, "Bank Account No.:"),
                            React.createElement("td", null, "11098064")),
                        React.createElement("tr", null,
                            React.createElement("th", null, "IBAN:"),
                            React.createElement("td", null, "IE37AIBK93329511098064")),
                        React.createElement("tr", null,
                            React.createElement("th", null, "BIC:"),
                            React.createElement("td", null, "AIBKIE2DXXX"))))))); } });
};
export default DonateForm;
